const FormResources = {

    form_data:  {
        cost_center_id:             '',
        cost_center_department_id:  '',
        name:                       '',
        last_name:                  '',
        email:                      '',
        ext:                        '',
        is_manager:                 false,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Cost Center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'First Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Last Name:',
            model_name: 'last_name',
            ref:        'last_name_input',
            ref_alt:    'last_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Ext:',
            model_name: 'ext',
            ref:        'ext_input',
            ref_alt:    'ext_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6 ',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Manager:',
            model_name: 'is_manager',
            ref:        'is_manager_input',
            ref_alt:    'is_manager_input_alt',
            required:   false,
        },
    ]

}

export default FormResources